<template>
  <div class="nothingCon flex-center">
    <img  @dragstart.prevent  src="../assets/img_kongshujv.png" alt="">
    <span>当前页面暂时没有内容～</span>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.nothingCon{
    width: 100%;
    height: 100%;
    flex-direction: column;
    padding: 30px 0;
    img{
        width: 300px;
        height: 300px;
    }
    span{
        font-size: 14px;
        color: #999999;
        line-height: 20px;
    }
}

</style>
